import React from 'react';
import { Play, Radio } from 'lucide-react';

const EMBED = 'https://www.youtube.com/embed/dQw4w9WgXcQ';

function VideoCard({ title, subtitle, live = false, testid, headerIcon: Icon }) {
  return (
    <div data-testid={testid} className="card-embossed p-5 sm:p-6">
      <div className="flex items-start justify-between mb-4 gap-3">
        <div>
          <div className="flex items-center gap-2 text-[#D4AF37] mb-1.5">
            <Icon size={16} />
            <p className="text-xs uppercase tracking-[0.28em] font-semibold">{title}</p>
          </div>
          <p className="text-sm text-[#C0C0C0]/85">{subtitle}</p>
        </div>
        {live && (
          <span
            data-testid="live-badge"
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#0a0a0a] border border-[#D4AF37]/40 text-[10px] uppercase tracking-widest text-[#D4AF37]"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#FFD700] pulse-gold" />
            Live
          </span>
        )}
      </div>
      <div className="relative w-full rounded-lg overflow-hidden border border-[#D4AF37]/25" style={{ aspectRatio: '16 / 9' }}>
        <iframe
          data-testid={`${testid}-iframe`}
          src={EMBED}
          title={title}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default function HomeVideos() {
  return (
    <section
      data-testid="home-videos"
      className="py-14 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
    >
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-2">Golden Fish TV</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl font-black">
          <span className="text-gold-gradient">Watch, then win.</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <VideoCard
          testid="promo-video"
          headerIcon={Play}
          title="Watch Our Promo"
          subtitle="See how the Golden Catch changes lives."
        />
        <VideoCard
          testid="live-draw"
          headerIcon={Radio}
          title="Live Draw — Fridays 6PM SAST"
          subtitle="Tune in every Friday for the Golden Catch live draw."
          live
        />
      </div>
    </section>
  );
}
